import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { TrustBadges } from '../ui/TrustBadges';
import { SectionHeader } from '../ui/SectionHeader';
import { CheckIcon } from 'lucide-react';
export function Oferta() {
  const [timeLeft, setTimeLeft] = useState({
    h: 2,
    m: 0,
    s: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    let endTime = sessionStorage.getItem('countdown_end');
    if (!endTime) {
      endTime = (Date.now() + 2 * 60 * 60 * 1000).toString();
      sessionStorage.setItem('countdown_end', endTime);
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = parseInt(endTime!) - now;
      if (distance <= 0) {
        clearInterval(interval);
        setIsExpired(true);
      } else {
        setTimeLeft({
          h: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          m: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          s: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const includes = [{
    title: 'Ebook: Protocolo Digestivo de 72 Horas™',
    desc: 'Guía completa en PDF — descarga inmediata, leelo desde cualquier dispositivo',
    value: '$14.990'
  }, {
    title: 'Sistema de identificación de detonantes',
    desc: 'Método paso a paso para descubrir qué activa tu reflujo específicamente',
    value: '$4.990'
  }, {
    title: 'Plan de comidas de 72 horas',
    desc: 'Qué comer en cada momento del protocolo para calmar la irritación digestiva',
    value: '$3.990'
  }, {
    title: 'Rutina digestiva nocturna',
    desc: 'Protocolo específico para reducir los episodios de reflujo mientras dormís',
    value: '$2.990'
  }, {
    title: 'Remedio de emergencia',
    desc: 'Cómo prepararlo correctamente para que actúe en minutos cuando el ardor aparece',
    value: '$2.990'
  }, {
    title: 'Plan de mantenimiento post-protocolo',
    desc: 'Para sostener los resultados y que el reflujo no vuelva a controlar tu vida',
    value: '$3.990'
  }, {
    title: '3 Bonos exclusivos (Lista Negra + Cena Sin Castigo + SOS AntiAgrura)',
    desc: 'Valorados en más de $15.000 — incluidos sin costo adicional',
    value: '$15.970'
  }];
  return <section id="oferta" className="bg-verde-oscuro py-[100px] relative" data-id="element-195">
      <div className="container-custom" data-id="element-196">
        <SectionHeader eyebrow="Tu inversión hoy" title={<>
              Todo lo que recibís
              <br data-id="element-198" />
              con el Protocolo Digestivo de 72 Horas™
            </>} theme="dark" data-id="element-197" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start mt-[60px]" data-id="element-199">
          {/* Left Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 border border-white/10 rounded-[12px] p-8 md:p-10" data-id="element-200">
            <div className="font-display text-[20px] font-bold text-blanco mb-7 pb-4 border-b border-white/10" data-id="element-201">
              Todo lo que incluye
            </div>

            <div className="flex flex-col gap-4" data-id="element-202">
              {includes.map((item, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1,
              duration: 0.4
            }} className="flex items-start gap-3 pb-4 border-b border-white/5 last:border-0 last:pb-0" data-id="element-203">
                  <div className="shrink-0 w-5 h-5 bg-verde-claro rounded-full flex items-center justify-center mt-0.5" data-id="element-204">
                    <CheckIcon className="w-3.5 h-3.5 text-white" strokeWidth={3} data-id="element-205" />
                  </div>
                  <div className="flex-1" data-id="element-206">
                    <div className="flex items-baseline justify-between gap-2" data-id="element-207">
                      <strong className="text-[16px] md:text-[15px] font-semibold text-blanco block mb-0.5" data-id="element-208">
                        {item.title}
                      </strong>
                      <span className="text-[13px] text-dorado-claro font-semibold whitespace-nowrap shrink-0" data-id="element-209">
                        {item.value}
                      </span>
                    </div>
                    <span className="text-[15px] md:text-[14px] text-white/50" data-id="element-210">
                      {item.desc}
                    </span>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Right Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-crema border-2 border-dorado rounded-[12px] p-8 md:p-10 text-center" data-id="element-211">
            <div className="ebook-shine ebook-sparkle ebook-glow bg-gradient-to-br from-dorado/5 via-verde/10 to-dorado/5 rounded-[12px] p-8 mb-7 flex items-center justify-center" data-id="element-212">
              <img src="https://i.postimg.cc/ydTmpBFx/libro-principal.webp" alt="Protocolo Digestivo de 72 Horas — Ebook" className="w-full max-w-[320px] h-auto object-contain animate-float-premium drop-shadow-[0_15px_40px_rgba(201,162,39,0.2)]" data-id="element-213" />
            </div>

            <div className="text-[14px] md:text-[12px] font-bold tracking-[2px] uppercase text-verde mb-3" data-id="element-214">
              Formato del producto
            </div>

            <p className="text-[16px] md:text-[15px] text-gris-oscuro mb-4 leading-[1.6]" data-id="element-215">
              <strong data-id="element-216">Ebook digital en PDF</strong> — descarga inmediata, leelo
              desde cualquier dispositivo. Acceso{' '}
              <strong className="text-verde-oscuro" data-id="element-217">para siempre.</strong>
            </p>

            <p className="text-[14px] text-gris leading-[1.6]" data-id="element-218">
              Un único pago. Sin suscripciones. Sin costos ocultos.
            </p>

            <TrustBadges theme="light" className="mt-5" data-id="element-219" />
          </motion.div>
        </div>
      </div>
    </section>;
}